/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var useMouseEvents = require('./useMouseEvents.js');
var useMouseState = require('./useMouseState.js');

var useMouse = function useMouse() {
  var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var state = useMouseState.default(ref);
  var events = useMouseEvents.default(ref);
  return [state, events];
};

exports.default = useMouse;
